import {
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE,
  CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCustomComponentConfigs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/custom-component?min=true`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomComponentConfigsError() {
  return {
    type: CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_BEGIN:
      return {
        ...state,
        loadCustomComponentConfigsPending: true,
        loadCustomComponentConfigsError: null,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_SUCCESS:
      return {
        ...state,
        loadCustomComponentConfigsPending: false,
        loadCustomComponentConfigsError: null,
        customComponents: action.data,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_FAILURE:
      return {
        ...state,
        loadCustomComponentConfigsPending: false,
        loadCustomComponentConfigsError: action.data.error,
      };

    case CUSTOM_COMPONENT_LOAD_CUSTOM_COMPONENT_CONFIGS_DISMISS_ERROR:
      return {
        ...state,
        loadCustomComponentConfigsError: null,
      };

    default:
      return state;
  }
}
